export default __webpack_public_path__ + "static/media/search-black-icon.4bf46fd7.svg";